import React from "react";
import { Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import Container from 'react-bootstrap/Container';

function Home() {
    return (
        <HomeStyled className="table-responsive-sm">
            <Container>
                <h1>Tax Basecamp</h1>
                <p>Tax Resources for Tax Practitioners</p>
                <Row>
                    <Col>
                        <Card style={{ width: '18rem', height: '28rem' }}>
                            <Card.Img
                                id="federal"
                                variant="top"
                                src="https://westerncpe.s3.amazonaws.com/tax-app/federal-gradient.jpg"
                            />
                            <Card.ImgOverlay>
                                <Card.Title>Federal Tax</Card.Title>
                            </Card.ImgOverlay>
                            <Card.Body>
                                <Card.Text>
                                    View current and past Federal Tax Rate Schedules.
                                </Card.Text>
                                <a href="/federal/">
                                    <Button type='submit' id='submitBtn' className='SelectButton'>Go Now</Button>
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '18rem', height: '28rem' }}>
                            <Card.Img
                                id="cali"
                                variant="top"
                                src="https://westerncpe.s3.amazonaws.com/tax-app/california-gradient.jpg"
                                />
                            <Card.ImgOverlay>
                                <Card.Title>California Tax</Card.Title>
                            </Card.ImgOverlay>
                            <Card.Body>
                                <Card.Text>
                                    View current and past California Tax Rate Schedules.
                                </Card.Text>
                                <a href="/california">
                                    <Button type='submit' id='submitBtn' className='SelectButton'>Go Now</Button>
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '18rem', height: '28rem' }}>
                            <Card.Img
                                id="tax"
                                variant="top"
                                src="https://westerncpe.s3.amazonaws.com/tax-app/tax+calculator+(1).jpg"
                                />
                            <Card.ImgOverlay>
                                <Card.Title>Tax Calculator</Card.Title>
                            </Card.ImgOverlay>
                            <Card.Body>
                                <Card.Text>
                                    Calculate your taxes with our custom Tax Calculator.
                                </Card.Text>
                                <a href="/tax-calculator">
                                    <Button type='submit' id='submitBtn' className='SelectButton'>Go Now</Button>
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '18rem', height: '28rem' }}>
                            <Card.Img
                                id="add"
                                variant="top"
                                src="https://westerncpe.s3.amazonaws.com/tax-app/additional+resources+(1).jpg"
                                />
                            <Card.ImgOverlay>
                                <Card.Title>Additional Resources</Card.Title>
                            </Card.ImgOverlay>
                            <Card.Body>
                                <Card.Text>
                                    Check out all of our Additonal Resources.
                                </Card.Text>
                                <a href="/additional">
                                    <Button type='submit' id='submitBtn' className='SelectButton'>Go Now</Button>
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </HomeStyled>
    );
}
export default Home;

const HomeStyled = styled.div`
    min-height: 80vh;
    h1 {
        text-align: center;
        padding-top: 50px;
    }
    p {
        text-align: center;
        padding-bottom: 50px;
    }
    button{
        width: 175px;
        margin: 0 auto;
        display: block;
        margin-bottom: 0.5em;
    }
    #federal {
        border-bottom: 5px solid #00488E;
    }
    #cali {
        border-bottom: 5px solid #ea5151;
    }
    #add {
        border-bottom: 5px solid #66D49D;
    }
    #tax {
        border-bottom: 5px solid #99CCEE;
    }
    .card {
        padding-bottom: 0.5em;
        margin: 5px auto;
        .card-title {
            text-align: center;
            color: Black;
            font-weight: bold;
            padding-bottom: 0.5em;
        }
        .card-body{
            padding: 1.375rem 2rem;
        }
        .card-title {
            font-size: 25px;
            text-align: center;
            color: white;
            font-weight: bold;
            padding-bottom: 0.5em;
            margin-top: 25%;
        }
        .card-img-overlay{
            height: 0px;
            overflow: visible;
            pointer-events: none;
            background:none !important;
        }
    }
    @media (max-width: 767px) {
        .card {
            margin: 5px auto;
        }
        .col {
            margin-bottom: 15px;
        }
    }
    @media (min-width: 768px) {
        .card {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: auto;
        }
        .col {
            margin-bottom: 25px;
        }
    }
`;

